const App = () => {
    return (
        <>
            <p>Inbox1</p>
        </>
    );
};

export default App;
